// extracted by mini-css-extract-plugin
module.exports = {"cta":"cta__NEWMO"};